import { ChangeDetectorRef, Component, ElementRef, Input, NgZone, OnInit } from '@angular/core';
import { FocusMonitor } from '@angular/cdk/a11y';
import { MaskApplierService } from 'ngx-mask';
import { BaseFieldDirective } from '../base-field.directive';
import { TextField } from '../text-field/TextField';

@Component({
    selector: 'ui-cpf-cnpj-field',
    templateUrl: './cpf-cnpj-field.component.html',
    styleUrls: ['./cpf-cnpj-field.component.scss']
})
export class CpfCnpjFieldComponent extends BaseFieldDirective implements OnInit {

    @Input() config!: TextField;
    public valorFormatado: string = '';

    private patterns = {
        '0': { pattern: /[0-9]/ },
        'A': { pattern: /[A-Za-z0-9]/ }
    };

    constructor(
        private maskService: MaskApplierService,
        protected fmRef: FocusMonitor,
        protected elRef: ElementRef<HTMLElement>,
        protected changeDetector: ChangeDetectorRef,
        protected ngZone: NgZone
    ) {
        super(fmRef, elRef, changeDetector, ngZone);
    }

    public ngOnInit(): void {
        const valorInicial = this.controle?.value;
        if (valorInicial) {
            this.formatar(String(valorInicial));
        }
    }

    public onInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.formatar(input.value);
        input.value = this.valorFormatado;

        const valorSemMascara = this.valorFormatado.replace(/[^A-Za-z0-9]/g, '');
        this.controle?.setValue(valorSemMascara, { emitEvent: false });
    }

    private formatar(valor: string): void {
        const limpo = valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase().substring(0, 14);
        const ehCpf = limpo.length <= 11 && /^\d*$/.test(limpo);
        const mascara = ehCpf ? '000.000.000-00' : 'AA.AAA.AAA/AAAA-00';
        this.valorFormatado = this.maskService.applyMaskWithPattern(limpo, [mascara, this.patterns]);
    }
}